import React from 'react'

import { UserFilter } from '../TableHeader/FilterTypes'
import HoverTooltip from '../../../../../../components/HoverTooltip'

type Props = {
    role: string // Роль
    stage: string // Стадия
    isSelect: boolean // Выбрана
    isChernovik: boolean // Черновик
    isReady: boolean // Готово
    isCanMoveBackToEdit: boolean // Подготовка к размещению - Готово
    isCanMoveReadyToEis: boolean // Подготовка к размещению - Подготовка
    isSendPlan: boolean // Отправлен план
    isUpdatingFromEis: boolean // Обновление из ЕИС
    isAnnulate: boolean // Аннулирование
    multiSelect: boolean
    planVersionDiff: boolean
    filter: UserFilter | null
    theme: string
    actions: Actions // Функции кнопок
    // status: string
    // multiSelect: boolean
}

// Функции кнопок
type Actions = {
    ready_to_eis: () => void // Подготовить к отправке в ЕИС
    ready_to_go_eis: () => void // Изменение статуса на Готово к отправке
    delete: () => void // Удалить (относится только к драфтам)
    status_send_to_eis: () => void // Временно
}

type ButtonConfig = {
    id: string
    label: string
    onClick: () => void
    visibleCondition: boolean // Функция, проверяющая видимость
    className?: string // Стили для кнопки
    iconPathD: string
    iconFill: string
    disabled: boolean
    isLoading: boolean
}

const TableStageToolbarAdminButtons: React.FC<Props> = ({
    role,
    stage,
    isSelect,
    isChernovik,
    isReady,
    isCanMoveBackToEdit,
    isCanMoveReadyToEis,
    isSendPlan,
    isUpdatingFromEis,
    isAnnulate,
    multiSelect,
    planVersionDiff,
    filter,
    theme,
    actions,
    // status,
    // multiSelect,
}) => {
    const isAdmin = role === 'admin'
    const isSpecialist = role === 'specialist'
    const isCurator = role === 'curator'
    const isInitiator = role === 'initiator'

    const isEditStage = stage === 'Редактирование'
    const isRaedyStage = stage === 'Подготовка к размещению'
    const isSentToEisStage = stage === 'Отправка в ЕИС'
    const isPurchasePlanStage = stage === 'План закупки в ЕИС'

    const isFilter = filter?.filter_settings?.filter_enabled || false

    // const isEditStatus = status === 'Черновик'
    // const isReadyStatus = status === 'Готово'
    // const isStandStatus = status === 'Подготовка'
    // const isReadyToEisStatus = status === 'Готово к отправке'
    // const isSentToEisStatus = status === 'Отправлено в ЕИС'
    // const isPublishedStatus = status === 'Размещена'

    const buttons: ButtonConfig[] = [
        {
            id: 'ready_to_eis',
            label: 'Подготовить к отправке в ЕИС',
            onClick: actions.ready_to_eis,
            visibleCondition: isAdmin && isRaedyStage,
            className: `w-6 h-6 grid rounded-full place-items-center  ${isSelect && isCanMoveReadyToEis && !isSendPlan ? 'hover:bg-[#FFFFFF] dark:hover:bg-[#656365]' : ''}`,
            iconFill: `${isSelect && !isSendPlan ? (theme == 'dark' ? '#FFFFFF' : '#181818') : '#8A8A8A'}`,
            iconPathD:
                'M17.71,11.29l-4-4a1,1,0,1,0-1.42,1.42L14.59,11H3a1,1,0,0,0,0,2H14.59l-2.3,2.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l4-4a1,1,0,0,0,.21-.33,1,1,0,0,0,0-.76A1,1,0,0,0,17.71,11.29ZM21,4a1,1,0,0,0-1,1V19a1,1,0,0,0,2,0V5A1,1,0,0,0,21,4Z',
            disabled: !isSelect || isSendPlan,
            isLoading: false,
        },
        {
            id: 'status_send_to_eis',
            label: 'Поменять статус - Отапрвлено в ЕИС',
            onClick: actions.status_send_to_eis,
            visibleCondition: isAdmin && isSentToEisStage,
            className: `w-6 h-6 grid rounded-full place-items-center  ${isSelect && isCanMoveReadyToEis && !isSendPlan ? 'hover:bg-[#FFFFFF] dark:hover:bg-[#656365]' : ''}`,
            iconFill: `${isSelect && !isSendPlan ? (theme == 'dark' ? '#FFFFFF' : '#181818') : '#8A8A8A'}`,
            iconPathD:
                'M17.71,11.29l-4-4a1,1,0,1,0-1.42,1.42L14.59,11H3a1,1,0,0,0,0,2H14.59l-2.3,2.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l4-4a1,1,0,0,0,.21-.33,1,1,0,0,0,0-.76A1,1,0,0,0,17.71,11.29ZM21,4a1,1,0,0,0-1,1V19a1,1,0,0,0,2,0V5A1,1,0,0,0,21,4Z',
            disabled: !isSelect || isSendPlan,
            isLoading: false,
        },
        {
            id: 'delete',
            label: 'Удалить от админа',
            onClick: actions.delete,
            visibleCondition: isAdmin,
            className: `w-6 h-6 grid rounded-full place-items-center hover:bg-[#ed9cae] dark:hover:bg-[#701F1F]`,
            iconFill: `${theme == 'dark' ? '#FFFFFF' : '#181818'}`,
            iconPathD:
                'M10,18a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,10,18ZM20,6H16V5a3,3,0,0,0-3-3H11A3,3,0,0,0,8,5V6H4A1,1,0,0,0,4,8H5V19a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3V8h1a1,1,0,0,0,0-2ZM10,5a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1V6H10Zm7,14a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V8H17Zm-3-1a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,14,18Z',
            disabled: false,
            isLoading: false,
        },
    ]

    return (
        <>
            {buttons
                .filter((button) => button.visibleCondition) // Оставляем только видимые кнопки
                .map((button, index) => (
                    <button
                        key={index}
                        className={button.className}
                        onClick={button.onClick}
                        disabled={button.disabled}
                    >
                        {button.isLoading ? (
                            <HoverTooltip
                                tooltipText={button.label}
                                align="left"
                            >
                                <svg
                                    className="animate-spin h-4 w-4 text-[#181818] dark:text-[#FFFFFF]"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <circle
                                        className="opacity-25"
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        stroke="currentColor"
                                        strokeWidth="4"
                                    ></circle>
                                    <path
                                        className="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                    ></path>
                                </svg>
                            </HoverTooltip>
                        ) : (
                            <HoverTooltip
                                tooltipText={button.label}
                                align="left"
                            >
                                <svg
                                    className="w-4 h-4"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    id={button.id}
                                >
                                    <path
                                        fill={button.iconFill}
                                        d={button.iconPathD}
                                    ></path>
                                </svg>
                            </HoverTooltip>
                        )}
                    </button>
                ))}
        </>
    )
}

export default TableStageToolbarAdminButtons
